export default "__VITE_ASSET__Bnol$1ek__"